import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Avalista } from '../../../ficha-timeline/ficha-modal-avalista/model/avalista';

@Component({
  selector: 'app-avalista-card',
  templateUrl: './avalista-card.component.html',
  styleUrls: ['./avalista-card.component.scss'],
})
export class AvalistaCardComponent implements OnInit {
  @Input() index: number;
  @Input() avalista: Avalista;
  @Input() avalistas: Avalista[];
  @Input() showButtonClose: boolean;
  @Output() remover: EventEmitter<void> = new EventEmitter();
  @Output() editar: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public onClickRemove(): void {
    this.remover.emit();
  }

  public onClickEdit(): void {
    this.editar.emit();
  }

  public get hasPlaca():boolean {
    return !!this.avalista;
  }

  public get nomeAvalista(): string {
    return `${this.avalista.nome || ''}`;
  }

  public get cpfAvalista(): string {
    return `${this.avalista.cpf || ''}`;
  }

  public get hasAnyEdit(): boolean {
    return true;
  }

  public get title(): string {
    return 'Avalista incluído';
  }
}
